<template>
  <div style="display: flex">
    <span v-if="readOnly">{{ inputVal || '-' }}</span>
    <Input
      v-else
      :style="contentStyle"
      :validateEvent="false"
      ref="RefInput"
      class="pg-input"
      v-bind="$attrs"
      v-on="nowLisTeners"
      :value="inputVal"
      @keyup.enter.native="enter"
      @input="handleInput"
    >
      <template #prefix>
        <slot name="prefix"></slot>
      </template>
      <template #suffix>
        <slot name="suffix"></slot>
      </template>
      <template #prepend>
        <slot name="prepend"></slot>
      </template>
      <template #append>
        <slot name="append"></slot>
      </template>
    </Input>
  </div>
</template>
<script>
export default {
  name: 'PgInput',
  inheritAttrs: false,
}
</script>
<script setup>
import { ref, watch, useListeners, computed } from 'vue'
import { Input } from 'element-ui'
import { useFormItemValidate } from '../../form/hook/use-form-item-validate'

const props = defineProps({
  value: [String, Number],
  validateCustom: {
    type: Boolean,
    default: true,
  },
  readOnly: {
    type: Boolean,
    default: false,
  },
  contentStyle: Object,
})
const emit = defineEmits(['enter', 'input'])
const listeners = useListeners()
const nowLisTeners = computed(() => {
  const keys = Object.keys(listeners)
  return keys.reduce((pre, cur) => {
    if (cur !== 'input' && cur !== 'enter') {
      pre[cur] = listeners[cur]
    }
    return pre
  }, {})
})

const { formItemsChange } = useFormItemValidate()
const inputVal = ref(props.value)
watch(
  () => props.value,
  () => {
    props.validateCustom && formItemsChange()
    if (inputVal.value !== props.value) {
      inputVal.value = props.value
    }
  }
)
const handleInput = (val) => {
  inputVal.value = val
  emit('input', val)
}

const enter = ($event) => {
  emit('enter', $event.target.value, $event)
}

const RefInput = ref(null)
const focus = () => {
  RefInput.value?.focus()
}

defineExpose({
  focus,
  select: () => RefInput.value?.select(),
})
</script>
<style lang="scss">
@import '../style/input.scss';
</style>
